const fmt = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })

export const formatDate = (dateStr) => {
  if (!dateStr) return '-'
  try {
    return fmt.format(new Date(dateStr))
  } catch {
    return '-'
  }
}
